import React from 'react';
import PropTypes from 'prop-types';
// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BecomeHost.css';
// Component
import ListPlaceStep1 from '../../components/ListPlaceStep1';

class BecomeHost extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    mode: PropTypes.string,
    listId: PropTypes.number,
    formBaseURI: PropTypes.string,
    mode: PropTypes.string,
    hostId: PropTypes.string,
  };

  render() {
    const { title, formPage, formBaseURI, mode, listId, baseCurrency, step, hostId } = this.props;
    return (
      <>
        <ListPlaceStep1
          listId={listId}
          formPage={formPage}
          formBaseURI={formBaseURI}
          mode={mode}
          hostId={hostId}
          baseCurrency={baseCurrency}
          step={step}
        />
      </>
    );
  }
}

export default withStyles(s)(BecomeHost);